import React from 'react';
import { Badge } from '@wix/design-system';
import { Gift } from '@wix/wix-ui-icons-common/lazy';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
import s from './FreeDomainBadge.module.scss';
export const FreeDomainBadge = _ref => {
  let _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'tiny' : _ref$size;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.internals.useTranslations(),
    t = _DomainSearchSuiteMod.t;
  const badgeKey = 'domains_search_suite.anon_storefront_results.optimizations.initial_vs_renewal.voucher_badge';
  return /*#__PURE__*/React.createElement(Badge, {
    skin: "neutralSuccess",
    size: size,
    uppercase: false,
    prefixIcon: /*#__PURE__*/React.createElement(Gift, {
      width: 18,
      height: 18
    }),
    className: s.badge
  }, t(badgeKey));
};
//# sourceMappingURL=FreeDomainBadge.js.map